import {
  PUBLIC_ENVIRONMENT_NAME,
  PUBLIC_UNLEASH_PROXY_CLIENT_KEY,
  PUBLIC_UNLEASH_PROXY_CLIENT_REFRESH_INTERVAL,
  PUBLIC_UNLEASH_PROXY_CLIENT_URL,
} from '$env/static/public';

import { type IConfig } from '@unleash/proxy-client-svelte';

export const proxyConfig = {
  url: `${PUBLIC_UNLEASH_PROXY_CLIENT_URL}proxy`,
  clientKey: PUBLIC_UNLEASH_PROXY_CLIENT_KEY,
  refreshInterval: Number(PUBLIC_UNLEASH_PROXY_CLIENT_REFRESH_INTERVAL), // How often (in seconds) the client should poll the proxy for updates
  appName: '@do/store-client',
  environment: PUBLIC_ENVIRONMENT_NAME,
  disableMetrics: true,
} satisfies IConfig;
